export const languageEn = {
    home: 'Home',
    'report final': 'Report final',
    dashboard: 'Dashboard',
    logout: 'Logout',
    games: 'LOTO 5/90',
    report: 'Report',
    result: 'Result',
    about: 'About',
    print: 'Print',
    chance: 'Chance',
    nap: 'Nap',
    turbo: 'Turbo',
    'guinne turbo': 'Guinne turbo',
    'guinne nap': 'Guinne nap',
    'guinne chance': 'Guinne chance',
    'confirm delete': 'Confirm delete',
    'ask me later': 'Ask me later',
    'are you sure you want to delete?': 'Are you sure you want to delete?',
    add: 'Add',
    total: 'Total',
    clear: 'Clear',
    pay: 'Pay',
    no: 'No',
    cancel: 'Cancel',
    close: 'Close',
    ok: 'OK',
    back: 'Back',
    confirm: 'Confirm',
    select: 'Select',
    game: 'Game',
    wager: 'Wager',
    qp: 'QP',
    'please choose from 0 to 2 numbers': 'Please choose from 0 to 2 numbers!',
    'please choose from 0 to 3 numbers': 'Please choose from 0 to 3 numbers!',
    'please choose from 0 to 4 numbers': 'Please choose from 0 to 4 numbers!',
    'please choose from 0 to 5 numbers': 'Please choose from 0 to 5 numbers!',
    'please choose from 1 to 2 numbers': 'Please choose from 1 to 2 numbers!',
    'please choose from 1 to 3 numbers': 'Please choose from 1 to 3 numbers!',
    'please choose from 1 to 4 numbers': 'Please choose from 1 to 4 numbers!',
    'please choose from 1 to 5 numbers': 'Please choose from 1 to 5 numbers!',
    'please choose from 2 to 2 numbers': 'Please choose from 2 to 2 numbers!',
    'please choose from 2 to 3 numbers': 'Please choose from 2 to 3 numbers!',
    'please choose from 2 to 4 numbers': 'Please choose from 2 to 4 numbers!',
    'please choose from 2 to 5 numbers': 'Please choose from 2 to 5 numbers!',
    'please choose from 3 to 4 numbers': 'Please choose from 3 to 4 numbers!',
    'please choose from 3 to 5 numbers': 'Please choose from 3 to 5 numbers!',
    'please make sure that you select 2 of balls!': 'Please make sure that you select 2 of balls!',
    'please make sure that you select 3 of balls!': 'Please make sure that you select 3 of balls!',
    'please make sure that you select 4 of balls!': 'Please make sure that you select 4 of balls!',
    'please make sure that you select 5 of balls!': 'Please make sure that you select 5 of balls!',
    'amount due': 'Amount due',
    confirmation: 'Confirmation',
    'cash received': 'Cash received',
    'cash change': 'Cash change',
    'cash payment': 'Cash payment',
    'cash report': 'Cash report',
    'select date': 'Select date',
    'cash deposits': 'Cash deposits',
    cancellations: 'Cancellation Payouts',
    wagers: 'Wagers',
    winnings: 'Winnings',
    payouts: 'Winnings Payouts',
    'daily profit': 'Daily profit',
    'float adjustments': 'Float adjustments',
    'cash difference': 'Cash difference',
    results: 'Results',
    'guinee chance': 'Guinee chance',
    date: 'Date',
    'about games': 'About games',
    'loto turbo': 'Loto turbo',
    'loto nap': 'Loto nap',
    'loto chance': 'Loto chance',
    'nap 2: 2 numéros gagnants': 'Nap 2: 2 winning numbers',
    'nap 3: 3 numéros gagnants': 'Nap 3: 3 winning numbers',
    'nap 4: 4 numéros gagnants': 'Nap 4: 4 winning numbers',
    'nap 5: 5 numéros gagnants': 'Nap 5: 5 winning numbers',
    'chance 2: 2 numéros gagnants': 'Chance 2: 2 winning numbers',
    'chance 3: 3 numéros gagnants': 'Chance 3: 3 winning numbers',
    'chance 4: 4 numéros gagnants': 'Chance 4: 4 winning numbers',
    'chance 5: 5 numéros gagnants': 'Chance 5: 5 winning numbers',
    'turbo 2: 2 numéros gagnants': 'Turbo 2: 2 winning numbers',
    'turbo 3: 3 numéros gagnants': 'Turbo 3: 3 winning numbers',
    'turbo 4: 4 numéros gagnants': 'Turbo 4: 4 winning numbers',
    'turbo 5: 5 numéros gagnants': 'Turbo 5: 5 winning numbers',
    'nombre de numéros gagnants': 'Number of winning numbers',
    mise: 'Bet',
    'gains en gnf': 'Earnings in GNF',
    rescan: 'Rescan',
    'back to home': 'Back to home',
    loading: 'Loading',
    'loading...': 'Loading...',
    alert: 'Alert',
    'please input ticket number!': 'Please input ticket number!',
    error: 'Error',
    search: 'Search',
    'close scan': 'Close Scan',
    scan: 'Scan',
    'ticket number': 'Ticket number',
    'scan ticket': 'Scan ticket',
    'ticket code': 'Ticket code',
    'code ticket': 'Code ticket',
    or: 'OR',
    'ticket details': 'Ticket details',
    'purchase date': 'Purchase date',
    'payment received': 'Payment received',
    ticket: 'Ticket',
    draw: 'Draw',
    'draw date': 'Draw date',
    'make payment': 'Make payment',
    settling: 'Settling',
    settle: 'Settle',
    'no winnings': 'No winnings',
    'payment made': 'Payment made',
    'payment date': 'Payment date',
    amount: 'Amount',
    reference: 'Reference',
    'please input email and password!': 'Please input email and password!',
    'please input mobile number and pin!': 'Please input mobile number and pin!',
    'system error! Please try again later!': 'System error! Please try again later!',
    login: 'Login',
    'login by email': 'Login by email',
    'login by phone': 'Login by phone',
    'login terminal': 'Login terminal',
    terminal: 'Terminal',
    'terminal pin': 'Terminal pin',
    email: 'Email',
    password: 'Password',
    'mobile pin': 'Mobile pin',
    mobile: 'Mobile',
    'guinee lotto 5/90': 'Guinee lotto 5/90',
    'guinee lotto 6/45': 'Guinee lotto 6/45',
    'lotto 5/90': 'Lotto 5/90',
    'report of': 'Report of',
    receipt: 'RECEIPT',
    branch: 'Branch',
    cashier: 'Cashier',
    code: 'Code',
    settlement: 'Settlement',
    'guinee lottery': 'Guinee Lottery',
    end: 'END',
    'empty result': 'Empty result',
    warning: 'Warning',
    'play again': 'Play again',
    submitting: 'Submitting',
    'pending results': 'Pending results',
    'the amount entered is less that the amount required!': 'The amount entered is less than the amount required!',
    'system error!': 'System error!',
    'error - insufficient credit on the account': 'The amount entered is less that the amount required!',
    previous: 'Previous',
    next: 'Next',
    'all winning bets are cashout already!': 'All winning bets are cashout already',
    'ticket not found': 'ticket not found',
    'not found': 'NOT FOUND',
    'please input old pin and new pin!': 'Please input old pin and new pin!',
    'change pin': 'Change PIN',
    'old pin': 'Old PIN',
    'new pin': 'New PIN',
    'new pin retype': 'New PIN confirm',
    'cashier need to login again after pin is changed.': 'Cashier need to login again after PIN is changed.',
    'terminal pin must be digit number, minimum length is 6 and maximum length is 20!':
    'Terminal PIN must be digit number, minimum length is 6 and maximum length is 20!',
    'terminal pin is not initialized at start. please contact admin!': 'Terminal PIN is not initialized at start. Please contact admin!',
    'old terminal pin is not matched!': 'Old Terminal PIN is not matched!',
    'pin is changed!': 'PIN is changed!',
    'this winnings ticket is expired!': 'This winnings ticket is expired!',
    'select all': 'Select All',
    'select event': 'Select Event',
    continue: 'continue',
    'please select a date': 'Please select a date',
    'transaction completed!': 'Transaction completed!',
    'transaction completed': 'Transaction completed',
    'cart empty': 'cart empty',
    'continue paying': 'Continue paying',
    success: 'Success',
    min: 'min',
    max: 'max',
    'quick Pick': 'Quick Pick',
    'add to cart': 'Add to cart',
    'please choose the game': 'Please choose your draw',
    'add bets': 'Add Bets',
    'gains valides pendant 7 jours': 'Gains valides pendant 7 jours',
    'gortune aux parieurs et bénéfice à la nation': 'Fortune aux parieurs et bénéfice à la Nation',
    betslip: 'Betslip',
    'betslip cart': 'betslip',
    'betslip id': 'Betslip ID',
    multiple: 'Multiple',
    lines: 'lines',
    'total odds': 'Total odds',
    'possible winnings': 'Possible Winnings',
    single: 'Single',
    'wager ticket': 'wager',
    reallotto: 'Lotto 5/90',
    'bitville-sports': 'Sports',
    sports: 'SPORTS',
    number: 'NUMBER',
    summary: 'Summary',
    'true balance': 'True Balance',
    lotto: 'Lotto',
    'at least one of the events passed is invalid. please provide valid events.':
        'At least one of the events passed is invalid. Please provide valid events.',
    settings: 'Settings',
    'select printer': 'Select Printer',
    'draw name': 'Draw name',
    'draw time': 'Draw Time',
    'draw number': 'Draw Number',
    'rebet completed!': 'Rebet completed!',
    rebet: 'Rebet',
    'database error': 'Please contact the administrator, your balance is blocked.',
    'bonus percent': 'Bonus Percent',
    'from must be before to!': 'FROM must be before TO!',
    result2: 'Result',
    'change account': 'Change Account',
    replay: 'Replay',
    'replay completed!': 'Replay completed!',
    'not allow rebet': 'This ticket is not allowed to rebet!',
    'report date': 'report date',
    'print date': 'print date',
    'confirm final print':
        'Attention, while performing this process, you are closing your sales for the day. The terminal will be in a "Waiting" state until your deposit. In case of an error, please contact your support.',
    'please make sure that you select [number] of balls!': 'please make sure that you select [number] of balls!',
    'select a date': 'Select A Date',
    'select the event': 'Select the event',
    'transaction history': 'Transaction History',
    'your last [length] tickets': 'Your Last [length] Tickets',
    'your last [length] ticket': 'Your Last [length] Ticket',
    'turbo [number]': 'turbo [number]',
    'nap [number]': 'nap [number]',
    'chance [number]': 'chance [number]',
    bet: 'Bet',
    'bets [quantity]': 'Bets [quantity]',
    earnings: 'Earnings',
    selection: 'Selection',
    'loto [title]': 'Loto [title]',
    'loto payouts': 'Loto payouts',
    'loto turbo winnings': 'Loto Turbo Winnings',
    'number of winning numbers': 'Number Of Winning Numbers',
    odds: 'Odds',
    'results - change to loto 5/90': 'Results - Change to Loto 5/90',
    'no result': 'No Result',
    history: 'HISTORY',
    'next date': 'next date',
    'previous date': 'previous date',
    refresh: 'refresh',
    'quick pick': 'quick pick',
    'please login!': 'please login!',
    yes: 'yes',
    'no data': 'no data',
    'invalid credentials.': 'invalid credentials.',
    'lotto 6 of 45': 'Loto 6/45',
    'select game': 'Select Game',
    'cancel successfully': 'cancel successfully',
    "we're not allow rebet for 6/45": "We're Not Allow Rebet For 6/45",
    'invalid account credentials, please contact technical support.': 'invalid Account Credentials, Please Contact Technical Support.',
    'numbers n': 'Numbers N.',
    payout: 'Payout',
    'odds (1 over)': 'Odds (1 over)',
    'loto 6/45': 'Loto 6/45',
    'match numbers': 'match numbers',
    winners: 'winners',
    'lotto-6-45': 'Loto 6/45',
    combination: 'combination',
    multiplePrint: 'Multiple',
    simple: 'Simple',
    '1 numéro': '1 number',
    '2 numéros': '2 numbers',
    '3 numéros': '3 numbers',
    '4 numéros': '4 numbers',
    '5 numéros': '5 numbers',
    '0 numéro + 2 bonus': '0 number + 2 bonuses',
    '0 numéro + 1 bonus': '0 number + 1 bonus',
    '1 numéro + 1 bonus': '1 number + 1 bonus',
    '1 numéro + 2 bonus': '1 number + 2 bonuses',
    '2 numéros + 2 bonus': '2 numbers + 2 bonuses',
    '2 numéros + 1 bonus': '2 numbers + 1 bonus',
    '3 numéros + 1 bonus': '3 numbers + 1 bonus',
    '3 numéros + 2 bonus': '3 numbers + 2 bonuses',
    '4 numéros + 1 bonus': '4 numbers + 1 bonus',
    'test print': 'Test print',
    'lucky numbers': 'LUCKY NUMBERS',
    'no site setting': 'No Site Setting',
    'numbers betting': 'NUMBERS BETTING',
    pick: 'Pick',
    paid: 'Paid',
    'total bet amount': 'Total Bet Amount',
    'total bets': 'Total Bets',
    numbersbetting: 'Numbers',
    'please allow bluetooth permission!': 'Please allow bluetooth permission!',
    'go to settings': 'Go to Settings',
    'please input terminal and terminal pin': 'Please input Terminal and Terminal Pin',
    verison: 'Verison',
    'number betting': 'NUMBER BETTING',
    'new pin and confirm pin do not match!': 'New pin and confirm pin do not match!',
    'transaction identifier: [id]': 'Transaction identifier: [id]',
    'log-in detaillant': 'Login Details',
    'user id': 'User ID',
    lucky: 'Loto 5/90',
    'okapi lottery': 'Multi loto 5/90',
    'multi loto 5/90': 'loto 5/90',
    'lotto-opaki-5-90-lucky5': 'lucky 5',
    'lotto-opaki-5-90-lucky4': 'lucky 4',
    'lotto-opaki-5-90-lucky3': 'lucky 3',
    'no ticket': 'no',
    'sports betting': 'SPORTS BETTING',
    'lotto daily': 'Lotto 5/90',
    'inhouse games': 'InHouse',
    'outdoor games': 'OutDoor',
    effacer: 'Clear',
    valide: 'Pay',
    'numéros gagnants': 'Winning numbers',
    numéros: 'numbers',
    'choisissez toujours 5 numéros': 'Always choose 5 numbers',
    'choisissez toujours 4 numéros': 'Always choose 4 numbers',
    'choisissez toujours 3 numéros': 'Always choose 3 numbers',
    abouts: 'about',
    'non - cancel': 'no - cancel',
    'non - reprint': 'no - reprint',
    'lotto-daily': 'Lotto',
    'gab lotto limited': 'Gab Lotto Limited',
    'example stake': 'Example Stake',
    'winning (example)': 'Winning (Example)',
    'is played by selecting a single number out of 90': 'is played by selecting a single number out of 90',
    'pick [pick] to [to] numbers, need at least [least] to win. lines generated based on selections': 'Pick [pick] to [to] numbers, need at least [least] to win. Lines generated based on selections.',
    '[ball] banker': '[ball] Banker',
    'total stake = single stake amount x 89': 'Total stake = Single stake amount X 89',
    '[odd] x single stake': '[odd] X Single stake',
    'terminal id': 'Terminal ID',
    'sales time': 'Sales Time',
    'ticker number': 'Ticker Number',
    'good luck': 'Good Luck',
    'this is valid for [date] days ending': 'This is valid for [date] days ending',
    'customer care line (whatsapp)': 'Customer Care line (WhatsApp)',
    'yafun-yafun': 'Yafun Yafun',
    'gab-yafun-yafun': 'Yafun Yafun',
    stake: 'Stake',
    stakes: 'Stakes',
};
